import type from "./type";

export default type("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
});



//////////////////
// WEBPACK FOOTER
// ./~/d3-request/src/html.js
// module id = 1915
// module chunks = 0